<template>
  <div :class="[$b(), 'ignore-theme']">
    <div :class="[...$b('wrapper'), 'global-wrapper']">
      <div :class="$b('carousel')">
        <Swiper
          init
          a11y
          loop
          :autoplay="{
            delay: slideDuration,
            disableOnInteraction: false,
            waitForTransition: false,
          }"
          effect="fade"
          :fade-effect="{ crossFade: true }"
          :modules="[Autoplay, EffectFade]"
          :keyboard="{
            enabled: true,
          }"
          :loop-prevents-slide="false"
          :speed="slideTransitionDuration"
          @swiper="handleSwiperReady"
          @slide-change="handleSlideChange"
        >
          <SwiperSlide
            v-if="slides.includes('BCorpBanner')"
          >
            <BCorpBanner />
          </SwiperSlide>

          <SwiperSlide
            v-if="slides.includes('OnePercentBanner')"
          >
            <OnePercentBanner />
          </SwiperSlide>

          <SwiperSlide
            v-if="slides.includes('CarbonNeutralBanner')"
          >
            <CarbonNeutralBanner />
          </SwiperSlide>

          <ul :class="$b('pagination')">
            <li
              v-for="(slide, index) in slides"
              :key="index"
            >
              <TimerButton
                :is-active="isReady && activeIndex === index"
                :gradient-id="`${index}`"
                @click="transitionToSlide(index)"
              />
            </li>
          </ul>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct';
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, EffectFade } from 'swiper/modules'

export default {
  name: 'ProductBannerCarousel',
  
  components: {
    Swiper,
    SwiperSlide
  },

  props: {
    customisedProduct: {
      type: CustomisedProduct,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },

  setup () {
    return {
      Autoplay,
      EffectFade
    }
  },

  data() {
    return {
      swiper: null,
      slideDuration: 8000,
      slideTransitionDuration: 300,
      isReady: false,
      activeIndex: 0
    }
  },

  computed: {
    slides () {
      const slides = ['BCorpBanner', 'OnePercentBanner', 'CarbonNeutralBanner']
      return slides
    }
  },

  beforeUnmount () {
    this.swiper?.destroy()
    this.swiper = null
    this.isReady = false
  },

  methods: {
    handleSwiperReady (swiper) {
      this.swiper = swiper
      this.isReady = true
    },

    handleSlideChange (event) {
      this.activeIndex = event.realIndex
    },

    transitionToSlide(index) {
      this.swiper.slideToLoop(index, this.slideTransitionDuration)
    }
  },
}
</script>

<style lang="postcss" scoped>
.ProductBannerCarousel {
  @apply bg-grey-light
    pt-[90px] pb-[60px];

  @screen xxs {
    @apply pt-[120px] pb-[80px];
  }

  @screen lg {
    @apply pt-[140px];
  }

  &__wrapper {
    @screen md {
      @apply min-h-[350px];
    }
  }

  .is-dark-chrome-theme & {
    @apply text-off-black;
  }
}

.ProductBannerCarousel__pagination {
  @apply flex shrink-0 z-10 justify-end;
}
</style>
